import { inject, Injectable } from '@angular/core';
import { EDeliverableType } from '@enums/campaign.enum';
import { IDeliverableConfig } from '../deliverable-list.interface';
import { ImageDeliverableService } from '../shared/image-deliverable/image-deliverable.service';
import { ShowcaseComponent } from './showcase.component';

@Injectable({ providedIn: 'root' })
export class ShowcaseService {
  private readonly imageDeliverableService = inject(ImageDeliverableService);

  public getConfig(): IDeliverableConfig {
    return this.imageDeliverableService.getConfig({
      component: ShowcaseComponent,
      defaultNameTranslationKey: 'pages.campaignForm.ctaDialog.ctaDetails.deliverables.showcaseDeliverable.title',
      deliverableType: EDeliverableType.showcase,
    });
  }
}
